import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// css
import "./vraRadPool.css"
// mui
import Tables from "components/table/table";
import leftarrow from "assets/images/arrow-right.png";
import vraRadPoolAPI from "apis/panel/vraRadPool/vraRadPool"
import Context from "context/context";
import NotificationsIcon from '@mui/icons-material/Notifications';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';

import 'react-calendar/dist/Calendar.css';
import moment from 'moment';

import EditVraRadPool from "./EditVraRadPool";


const style = {
  position: 'absolute',
  top: '60%',
  left: '60%',
  transform: 'translate(-60%, -60%)',
  width: "98%",
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const VraRadPool = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();

 const {getAllVraRadPoolAPI, getVraNeededWarningCountAPI, getAllVraNeededWarningAPI} = vraRadPoolAPI()
 
  const [vraRadPoolDetails, setVraRadPoolDetails] = useState([])
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  
  
  const [editData, setEditData] = useState(null);
  const [open, setOpen] = useState(false);
  
  const [serialNumber, setSerialNumber] = useState("");

  const [warningCount, setWarningCount] = useState(0);
  const [warningOffset, setWarningOffset] = useState(1);
  const [warningData, setWarningData] = useState([]);
  const [warningModal, setWarningModal] = useState(false);

const handleEdit = async(id)=>{
    setOpen(true)
   
    const dataToEdit = vraRadPoolDetails.find(item => item.vraRadMappingId === id);
        if (dataToEdit) {
          setEditData(dataToEdit);  
        } else {
          console.error('Data not found for the provided id');
        }

 
}

const handleNavigation=()=>{
  navigate("/panel/rpHomePage")
}


const handleClose= async()=>{
  
  setOpen(false)
  setEditData(null);
}

  const handleGetAllVraRadPoolDetailsApi = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20,
      };
      if (searchValue) {
        values = {
            ...values,
          searchValue,
        };
      }
     
      let res = await getAllVraRadPoolAPI(values);
      setVraRadPoolDetails(res?.data?.data|| []);
      setCount(res?.data?.totalCount);
      setSerialNumber(offset)
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  useEffect(() => {
   
    handleGetAllVraRadPoolDetailsApi()
  }, [offset, searchValue,open])

  useEffect(() => {
    handleGetVraNeededWarningCountAPI()
  }, [])

  const handleGetVraNeededWarningCountAPI = async () => {
    console.log("i am inside the API")
    try {
      let res = await getVraNeededWarningCountAPI();
      console.log({res})
      setWarningCount(res?.data?.totalCount);
    } catch (err) {
    }
  };

  useEffect(() => {
    handleGetVraNeededWarningAPI()
  }, [warningOffset])

  const handleGetVraNeededWarningAPI = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (warningOffset - 1) * 20,
        limit: 20,
      };
     
      let res = await getAllVraNeededWarningAPI(values);
      setWarningData(res?.data?.data|| []);
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  return (
    <div
      className="vraPoolMediaQuery"
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <Tables
       title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
            <img src={leftarrow} alt="Back" />
          </div>
          <Box sx={{ pt: 2, pb: 2 }} className="VraPoolTitle">
          VRA RAD Pool Roster
          </Box>
        </div>
      }
      centerContent={
        <span  style={{marginRight:"20px", cursor:"pointer",fontSize:"20px"}} onClick={()=>{
          setWarningModal(true)
          if(warningOffset === 1){
            handleGetVraNeededWarningAPI()
          }else{
            warningOffset(1)
          }
          }}>
        <Badge badgeContent={warningCount||0} color="error">
        <NotificationsIcon/>
      </Badge>
      </span>
      }
        searchBar={true}
        filter={false}
        role={roleCode}
        
        setSearchValue={setSearchValue}
       
        heading={[
          "S.No",
          "RAD Name",
          "RAD Deployed Date",
          "No of VRA's needed",
          "Primary VRA",
          "Secondary VRA",
          "Third VRA",
          "Fourth VRA",
          "Total VRAs in the Pool" ,
          "Updated On",
          "Actions"     
        ]}
        data={vraRadPoolDetails?.map((e, index) => [
              index + 1 + (serialNumber - 1) * 20,   
              e.radSrfName ,
              e.radDeployedDate ? moment(e.radDeployedDate).format('DD-MMM-YYYY') : e.radDeployedDate,,
              e.noOfVraNeeded,
              e.vra1SrfName,      
              e.vra2SrfName,
              e.vra3SrfName,
              e.vra4SrfName,
              e.totalVra,
              <span style={{whiteSpace:"nowrap"}}>{e.updatedOn}</span>,
              <EditIcon style={{color:"#FE6024",cursor: 'pointer'}}  onClick={() => handleEdit(e.vraRadMappingId)}/>,
         ])}
         offset={offset}
         limit={20}
         setOffset={setOffset}
         count={count}
         placeholder="Search by RAD Name or VRA Names"
         />
  {/* Edit Modal */}
    <Modal open={open}  onClose={handleClose} className="custom-modal">
   <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: "80%",
      maxWidth: "800px",
      bgcolor: 'background.paper',
      padding: "24px",
      borderRadius: "8px",
     
     
    }}>
         <EditVraRadPool data={editData} onClose={handleClose} warningModal={warningModal} setWarningModal={setWarningModal} handleGetVraNeededWarningCountAPI={handleGetVraNeededWarningCountAPI}/>
        </Box>
      </Modal>
     {/* Warning Modal */}
     <Dialog
        open={warningModal}
        onClose={()=>{setWarningModal(false)}}
        aria-labelledby="responsive-dialog-title"
        maxWidth='xl'
      >
              <Tables
       title={
          <Box sx={{ pt: 2, pb: 2 }} className="VraPoolTitle">
          Discrepancy in VRA's Needed vs Pool Allocation
          </Box>
      }
      centerContent={
        <span style={{cursor:"pointer",fontSize:"20px"}} onClick={()=>{setWarningModal(false)}}>
        <CancelOutlinedIcon style={{fontSize:"30px", color:"red"}}/>
      </span>
      }
        heading={[
          "S.No",
          "RAD Name",
          "RAD Deployed Date",
          "No of VRA's needed",
          "Primary VRA",
          "Secondary VRA",
          "Third VRA",
          "Fourth VRA",
          "Total VRAs in the Pool" ,
          "Updated On",
        ]}
        data={warningData?.map((e, index) => [
              index + 1 + (warningOffset - 1) * 20,   
              e.radSrfName ,
              e.radDeployedDate ? moment(e.radDeployedDate).format('DD-MMM-YYYY') : e.radDeployedDate,,
              e.noOfVraNeeded,
              e.vra1SrfName,      
              e.vra2SrfName,
              e.vra3SrfName,
              e.vra4SrfName,
              e.totalVra,
              <span style={{whiteSpace:"nowrap"}}>{e.updatedOn}</span>,
         ])}
         offset={warningOffset}
         limit={20}
         setOffset={setWarningOffset}
         count={warningCount}
         searchBar={false}
         setSearchValue={setSearchValue}
         />
      </Dialog>
    </div>
  )
}


export default VraRadPool